var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBread = function SvgBread(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.274 5.896-.153.251a2.791 2.791 0 0 0 .395 3.4c.128.13.2.305.2.488v8.215a1 1 0 0 0 1 1h10.576a1 1 0 0 0 1-1v-8.215a.7.7 0 0 1 .199-.489 2.796 2.796 0 0 0 .393-3.396l-.15-.25a2.38 2.38 0 0 0-2.037-1.15h-9.39c-.832 0-1.603.435-2.033 1.146Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgBread;